import { render } from "./ServOrderList.vue?vue&type=template&id=12a8aaea"
import script from "./ServOrderList.vue?vue&type=script&lang=js"
export * from "./ServOrderList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__